import { get, post } from './request';

// 获取问卷列表
export var getQuesList = function getQuesList(data) {
  return get('/question_active/topic', data);
};

// 获取问卷信息
export var getQuesInfo = function getQuesInfo(data) {
  return get('/question_active/info', data);
};

// 获取个人信息题列表
export var getPessonQuesList = function getPessonQuesList(data) {
  return get('/question_active/question_user', data);
};

// 获取学习问卷列表
export var getStudyQuesList = function getStudyQuesList(data) {
  return get('/question_active/get_question_list', data);
};

// 获取微信配置信息
export var getWxShareInfo = function getWxShareInfo(data) {
  return get('/share_info', data);
};

// 获取分享配置信息
export var getShareConfig = function getShareConfig(data) {
  return get('/share_info', data);
};

// 提交答案
export var submitAnswer = function submitAnswer(data) {
  return post('/answer/answer_question', data);
};

// 获取试卷结果
export var getResult = function getResult(data) {
  return post('/answer/exam_info', data);
};

// 回顾试卷
export var getReview = function getReview(data) {
  return get('/question_active/get_question_review', data);
};

// 获取单位列表
export var getUnitList = function getUnitList(data) {
  return get('/unit/active_list', data);
};

// 获取答题次数
export var getSubmitCount = function getSubmitCount(data) {
  return get('/answer/submit_status', data);
};

// 查看个人排名
export var getPersonRank = function getPersonRank(data) {
  return get('/statistics/answer_group', data);
};

// 查看当前卷子排名
export var getRankByQues = function getRankByQues(data) {
  return get('/answer/rank_list', data);
};

// 查看当前活动单位排名
export var getRankByActivity = function getRankByActivity(data) {
  return get('/question_active/active_rank', data);
};

// 获取上传token
export var getUploadToken = function getUploadToken(data) {
  return get('/get_Token', data);
};

// 获取阿里云上传参数
export var getAliUploadConfig = function getAliUploadConfig() {
  return get('/assume_role');
};

// 指定账号密码登录
export var acountLogin = function acountLogin(data) {
  return post('/question_active/login', data);
};

// 获取问卷总分
export var getQuesTotalScore = function getQuesTotalScore(data) {
  return get('/question_active/score_active', data);
};

// 缓存问卷
export var cacheQues = function cacheQues(data) {
  return post('/answer/cache_save', data);
};

// 获取缓存问卷
export var getCacheQues = function getCacheQues(data) {
  return get('/answer/cache_get', data);
};

// 更改缓存问卷状态
export var changeCacheQuesStatus = function changeCacheQuesStatus(data) {
  return post('/answer/cache_update', data);
};